import React, { useState, useEffect, useContext } from 'react';
import { Dimmer, Loader } from 'semantic-ui-react';
import { getMyPaymentManager } from '../../../services/quotas';
import RedirectContext from '../../../contexts/RedirectContext';

const Payments = (props) => {
    const toggleRedirect = useContext(RedirectContext);

    useEffect(() => {
        getMyPaymentManager().then((pm) => {
            if (pm && pm.pm._id) {
                toggleRedirect(`/public/checkout/${pm.pm._id}`);
            } else {
                toggleRedirect('/activities');
            }
        });
    }, []);

    return (
        <Dimmer active={true}>
            <Loader loading={true}></Loader>
        </Dimmer>
    );
};
export default Payments;
